import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) { return twMerge(clsx(inputs)); }

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(String(iso) + (String(iso).length === 10 ? "T00:00:00" : ""));
  return isNaN(d) ? String(iso) : d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d) ? String(iso) : d.toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const initials = (name) =>
  (name || "").split(/[\s@]/).filter(Boolean).slice(0, 2).map(w => w[0]?.toUpperCase() || "").join("");

export const statusColor = (s) => ({
  confirmed:        "text-green-600 bg-green-50 dark:bg-green-950/40 dark:text-green-400",
  pending:          "text-amber-600 bg-amber-50 dark:bg-amber-950/40 dark:text-amber-400",
  pending_approval: "text-amber-600 bg-amber-50 dark:bg-amber-950/40 dark:text-amber-400",
  cancelled:        "text-red-500 bg-red-50 dark:bg-red-950/40 dark:text-red-400",
  rejected:         "text-red-500 bg-red-50 dark:bg-red-950/40 dark:text-red-400",
  waitlist:         "text-blue-600 bg-blue-50 dark:bg-blue-950/40 dark:text-blue-400",
  published:        "text-green-600 bg-green-50 dark:bg-green-950/40 dark:text-green-400",
  approved:         "text-blue-600 bg-blue-50 dark:bg-blue-950/40 dark:text-blue-400",
  internal:         "text-slate-600 bg-slate-100 dark:bg-slate-800 dark:text-slate-300",
  public:           "text-green-600 bg-green-50 dark:bg-green-950/40 dark:text-green-400",
  private:          "text-slate-600 bg-slate-100 dark:bg-slate-800 dark:text-slate-300",
  maintenance:      "text-orange-600 bg-orange-50 dark:bg-orange-950/40 dark:text-orange-400",
  active:           "text-green-600 bg-green-50 dark:bg-green-950/40 dark:text-green-400",
  inactive:         "text-slate-500 bg-slate-100 dark:bg-slate-800",
  pending_review:   "text-amber-600 bg-amber-50 dark:bg-amber-950/40 dark:text-amber-400",
}[s?.toLowerCase()] || "text-slate-600 bg-slate-100 dark:bg-slate-800 dark:text-slate-300");

export const EVENT_TYPES = [
  { id: "seminar",    label: "Seminar"    },
  { id: "workshop",   label: "Workshop"   },
  { id: "guest_talk", label: "Guest Talk" },
  { id: "hackathon",  label: "Hackathon"  },
  { id: "placement",  label: "Placement"  },
  { id: "cultural",   label: "Cultural"   },
  { id: "conference", label: "Conference" },
  { id: "other",      label: "Other"      },
];

export const TYPE_COLOR = {
  seminar:    "bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300",
  workshop:   "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
  guest_talk: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300",
  hackathon:  "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300",
  placement:  "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300",
  cultural:   "bg-pink-100 text-pink-700 dark:bg-pink-900/40 dark:text-pink-300",
  conference: "bg-cyan-100 text-cyan-700 dark:bg-cyan-900/40 dark:text-cyan-300",
  other:      "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
};
